import Skeleton from "@material-ui/lab/Skeleton";
import { SVGProps } from "react";

import { List } from "./List";

type MenuLink = {
  i18nName: string;
  path: string;
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  showChildrenInSidebar?: boolean;
  children?: Omit<MenuLink, "showChildrenInSidebar" | "children">[];
};

export type LinksType = MenuLink[];

type MenuProps = {
  isLoading: boolean;
  links: LinksType;
  activePath: string;
};

export const Menu = ({ activePath, isLoading = false, links }: MenuProps) => {
  if (isLoading) {
    return (
      <>
        {links.map(() => (
          <Skeleton variant="rect" height={40} style={{ marginBottom: 16 }} />
        ))}
      </>
    );
  }

  return <List links={links} activePath={activePath} />;
};
